import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["name", "value"];
import { ref } from 'vue';
import MultipleFileUploader from '../../common/components/MultipleFileUploader.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EmotionImagesField',
    props: {
        images: { default: () => [] },
        imageUrlMap: { default: () => ({}) },
        name: { default: '' }
    },
    emits: ["update:images"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const errorMessage = ref('');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(MultipleFileUploader, {
                    ref: "uploader",
                    "model-value": __props.images,
                    folder: "assistant-emotions",
                    accept: "jpg,jpeg,png,gif,svg",
                    onError: _cache[0] || (_cache[0] = ($event) => (errorMessage.value = $event)),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:images', $event)))
                }, null, 8, ["model-value"]),
                (__props.name)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.images, (image) => {
                        return (_openBlock(), _createElementBlock("input", {
                            type: "hidden",
                            name: `${__props.name}[]`,
                            value: image.path
                        }, null, 8, _hoisted_1));
                    }), 256))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
